import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-quit-practice-dialog',
  templateUrl: './quit-practice-dialog.component.html',
  styleUrls: ['./quit-practice-dialog.component.css']
})
export class QuitPracticeDialogComponent implements OnInit {

  constructor(public dialog: MatDialog, 
    public selfLearnService : SelfLearnService,  
    public router : Router, public dialogRef: MatDialogRef<QuitPracticeDialogComponent>,  @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  navigateToPreviousPage(){
    this.close();
    const previousPage = localStorage.getItem("selfLearnPreviousPage");
    let isFromHomeScreen = localStorage.getItem('isFromHomeScreen');
    const navigationPath = isFromHomeScreen=='true' ?  localStorage.getItem('previousScreen') ?  localStorage.getItem('previousScreen') :'selfLearn-V2': (previousPage == 'practiceTopics') ? 'selfLearn-V2/practice-topics' : 'selfLearn-V2/chapter';
    localStorage.removeItem('isFromHomeScreen');
    this.router.navigateByUrl(navigationPath);
  }

  close() {
    this.dialogRef.close(true);
  }

}
